// PaginationBar2 ver 00

function PaginationBar2({
  currentPage,
  totalPages,
  itemsPerPage,
  totalItems,
  onPageChange,
  onLimitChange,
}) {
  const handlePageInputChange = (e) => {
    const newPage = parseInt(e.target.value, 10);
    if (!isNaN(newPage) && newPage >= 1 && newPage <= totalPages) {
      onPageChange(newPage);
    }
  };

  const handleLimitChange = (e) => {
    onLimitChange(parseInt(e.target.value, 10));
  };

  return (
    <div className="pagination-bar">
      <span>Page</span>
      <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
        &lt;
      </button>
      <input
        type="number"
        min="1"
        max={totalPages}
        value={currentPage}
        onChange={handlePageInputChange}
        onBlur={handlePageInputChange} // Update on blur if user types then clicks away
      />
      <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
        &gt;
      </button>
      <span>of {totalPages}</span>
      <span className="total-info">| Viewing</span>
      <select value={itemsPerPage} onChange={handleLimitChange}>
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
      <span>records</span>
      <span className="total-info">| Found total {totalItems} records</span>
    </div>
  );
}

export default PaginationBar2;